module.exports = __webpack_public_path__ + "img/checkbox.3713a0fc.png";